[
    {
        "Select": {
            "editable": false,
            "pinned": "left",
            "refData": {
                "datatype": "checkbox",
                "selectAll": true,
                "colSize": 50
            },
            "rowGroup": false,
            "hide": false,
            "maxWidth": 50,
            "suppressAutoSize": true
        },
        "Job Name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "flexSize": 2,
                "minWidth": 200
            },
            "rowGroup": false,
            "hide": false
        },
        "Distro id": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Channel": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Styc id": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Styc name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Buying Season": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Prior Selling Season(s)": {
            "editable": false,
            "refData": {
                "datatype": "array",
                "arrayKey": "season",
                "customNullValue": "Custom Season",
                "showToolTip": false,
                "custom_field": "prior_selling_seasons"
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Size Range": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": true,
                "tooltipField": "size_range"
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Size Count": {
            "editable": false,
            "refData": {
                "datatype": "number"
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Attribute Family": {
            "editable": false,
            "refData": {
                "datatype": "string"
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Attribute Value": {
            "editable": false,
            "refData": {
                "datatype": "string"
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Raw Sales": {
            "editable": false,
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "replaceZeros": true,
                "custom_field": "raw_sales"
            },
            "rowGroup": false,
            "hide": false
        },
        "Avg. Impact of Lost Sales": {
            "editable": false,
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "replaceZeros": true,
                "custom_field": "avg_impact_of_lost_sales"
            },
            "rowGroup": false,
            "hide": true
        },
        "Prod. Lvl": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": true,
                "replaceZeros": true,
                "custom_field": "optimal_node",
                "tooltipField": "optimal_nodes_count"
            },
            "rowGroup": false,
            "hide": true
        },
        "Distance from (-1)": {
            "editable": false,
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "custom_field": "distance_from_minusone"
            },
            "rowGroup": false,
            "hide": true
        },
        "Smoothing Impact": {
            "editable": false,
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "replaceZeros": true,
                "custom_field": "smoothing_impact"
            },
            "rowGroup": false,
            "hide": true
        },
        "Status": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "showAlert": true,
                "customAlertCompRef": "job-management-status-alert",
                "alertConditions": ["failed", "completed with errors"],
                "alertLinks": {
                    "completed with errors": {
                        "key": "job_name",
                        "action": "filter"
                    }
                },
                "flexSize": 2
            },
            "rowGroup": false,
            "hide": false
        },
        "Distro tag": {
            "editable": true,
            "refData": {
                "datatype": "string-editor",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Edited": {
            "editable": false,
            "refData": {
                "datatype": "boolean",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": true
        },
        "Last Modified": {
            "editable": false,
            "refData": {
                "datatype": "date",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false,
            "sort": "desc"
        },
        "Last Modified By": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": true
        }
    }
]
